import { gql } from '@apollo/client';
import { messageHeaders } from 'features/common/fragments';
import { cascoQuotationBase, cascoQuotationExtended } from 'features/insuranceDocument/queries/fragments';

export const QUOTATION_SAVED = gql`
  subscription cascoQuotationSaved($quotationId: Int!) {
    cascoQuotationSaved(quotationId: $quotationId) {
      insuranceQuotation {
        ...cascoQuotationBase
        ...cascoQuotationExtended
      }
      finishedRetrieval
      headers {
        ...messageHeaders
      }
    }
  }
  ${cascoQuotationBase}
  ${cascoQuotationExtended}
  ${messageHeaders}
`;

export const QUOTATION_LOCK_UPDATED = gql`
  subscription cascoQuotationLockUpdated($quotationId: Int!) {
    cascoQuotationLockUpdated(quotationId: $quotationId) {
      quotationId
      lockedYN
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const CONVENTIONS_QUOTATIONS_COMPUTING = gql`
  subscription conventionsQuotationsComputing($documentId: Int!) {
    conventionsQuotationsComputing(documentId: $documentId) {
      documentId
      insuranceQuotations {
        ...cascoQuotationBase
        ...cascoQuotationExtended
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${cascoQuotationBase}
  ${cascoQuotationExtended}
  ${messageHeaders}
`;

export const CONVENTIONS_QUOTATIONS_RETRIEVED = gql`
  subscription conventionsQuotationsRetrieved($documentId: Int!) {
    conventionsQuotationsRetrieved(documentId: $documentId) {
      insuranceQuotations {
        ...cascoQuotationBase
        ...cascoQuotationExtended
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${cascoQuotationBase}
  ${cascoQuotationExtended}
  ${messageHeaders}
`;

export const CONVENTION_QUOTATION_RETRIEVED = gql`
  subscription conventionQuotationRetrieved($quotationId: Int!) {
    conventionQuotationRetrieved(quotationId: $quotationId) {
      insuranceQuotation {
        ...cascoQuotationBase
        ...cascoQuotationExtended
      }
      silentMode
      headers {
        ...messageHeaders
      }
    }
  }
  ${cascoQuotationBase}
  ${cascoQuotationExtended}
  ${messageHeaders}
`;

export const CONVENTIONS_INITALIZED = gql`
  subscription conventionsInitialized($documentId: Int!) {
    conventionsInitialized(documentId: $documentId) {
      documentId
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const CASCO_QUOTATION_DATA_CHANGED = gql`
  subscription cascoQuotationDataChanged($documentId: Int!) {
    cascoQuotationDataChanged(documentId: $documentId) {
      documentId
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const CASCO_CUSTOM_QUOTATION_SAVED = gql`
  subscription cascoCustomQuotationSaved {
    cascoCustomQuotationSaved {
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const INSURANCE_QUOTATIONS_ARCHIVED = gql`
  subscription insuranceQuotationsArchived($documentId: Int!) {
    insuranceQuotationsArchived(documentId: $documentId) {
      documentId
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const INSURANCE_QUOTATIONS_INVALIDATED = gql`
  subscription insuranceQuotationsInvalidated($documentId: Int!) {
    insuranceQuotationsInvalidated(documentId: $documentId) {
      documentId
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const INSURANCE_CONVENTIONS_INVALIDATED = gql`
  subscription insuranceConventionsInvalidated {
    insuranceConventionsInvalidated {
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const RTI_RELATED_OFFER_FOUND = gql`
  subscription rtiRelatedOfferFound($documentId: Int!) {
    rtiRelatedOfferFound(documentId: $documentId) {
      documentId
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;
